$ = require 'jquery'
Browser = require '@trello/browser'
Footer = require 'views/footer'
Auth = require 'db/auth'
{ getQueryParameter } = require 'lib/util'

module.exports =
  maybeShowFooterChrome: (url) ->
    $el = $('#footer-chrome')
    $el.hide()

    if Browser.isEmbeddedDocument() and @onAnyBoardView()
      $el.show()
      footerView = new Footer({
        url
        shouldDisplayLogout: ->
          getQueryParameter('iframeSource', '') is 'msteams' and Auth.isLoggedIn()
      })
      $el.html footerView.render().el



// WEBPACK FOOTER //
// ./app/scripts/controller/footer.coffee